// Get the section element
const section = document.querySelector('.cette-hero-section');
const sticky = document.querySelector('.cette-hero__text-sticky');
const image1 = document.querySelector('.cette-hero__image-wrapper-1');
const image2 = document.querySelector('.cette-hero__image-wrapper-2');

// Check if user prefers reduced motion
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Create a new Intersection Observer
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (prefersReducedMotion) return; // a11y, no animation if user prefers it so
      // Remove any existing scroll classes
      section.classList.remove('not-in-view');
      section.classList.remove('scroll-up');
      section.classList.remove('scroll-down');
      // Handle intersection
      if (entry.isIntersecting) {
        // If section is in view, add scroll event listener for scroll animation mapping
        window.addEventListener('scroll', updateImagePosition);
        // CSS class based on scroll direction
        entry.boundingClientRect.top > 0 ? section.classList.add('scroll-down') : section.classList.add('scroll-up');
      } else {
        // If section is out of view, remove scroll event listener
        window.removeEventListener('scroll', updateImagePosition);
        section.classList.add('not-in-view');
        if (image1) image1.style.transform = `translateY(0)`;
        if (image2) image2.style.transform = `translateY(0)`;
      }
    });
  },
  // {
  //   root: null,
  //   rootMargin: '-120px',
  //   threshold: 0,
  // }
);

// const stickyObserver = new IntersectionObserver(
//   ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
//   { threshold: [1] }
// );

// Observe
observer.observe(section);
// stickyObserver.observe(sticky);

let sectionY = null; // store the section's Y position
const mapRange = (value, x1, y1, x2, y2) => ((value - x1) * (y2 - x2)) / (y1 - x1) + x2;
// const interpByPct = (pct, a, b) => (1 - pct) * a + pct * b;

// Function to update image position based on scroll
function updateImagePosition() {
  if (!section) return;

  // Set the section's original y position
  if (!sectionY) sectionY = section.getBoundingClientRect().top;

  // Get the scroll position and section dimensions
  const scrollPosition = window.scrollY;
  const sectionRect = section.getBoundingClientRect();

  // Calculate the percentage of the section in view
  const sectionInView = mapRange(scrollPosition, sectionY, sectionY + sectionRect.height, 0, 1);

  // Update positions
  if (sectionInView > 0) {
    // Calculate the image position based on the percentage
    const imagePos1 = sectionInView * 20; // interpByPct(sectionInView, 0, 100);
    const imagePos2 = sectionInView * -100;

    if (image1) image1.style.transform = `translateY(${imagePos1}%)`;
    if (image2) image2.style.transform = `translateY(${imagePos2}%)`;
  }
}
